module.exports = __webpack_public_path__ + "logo.svg?6387840f9b6e8720165db8c73185bc51";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.svg
// module id = 8
// module chunks = 0